import {BaseTypedValueType} from 'notebook/tables/typed-values/TypedValueConstants';
import {
  ProcedureConditionReplicate,
  ProcedureConditionReplicatesTypedValue,
} from 'notebook/tables/typed-values/TypedValueTypes';

export function toConditionReplicateString(conditionName: string, replicateNumber: number): string {
  return `${conditionName} ${replicateNumber}`;
}

/** Convert a single Condition-Replicate into a TypedValue. */
export function conditionReplicateToTypedValue(
  conditionReplicate: ProcedureConditionReplicate
): ProcedureConditionReplicatesTypedValue {
  return {
    type: BaseTypedValueType.PROCEDURE_CONDITION_REPLICATES,
    conditionReplicates: [conditionReplicate],
  };
}
